import { EventDispatcherSources } from '../events';
export var defaultAIEventsInstrumentationConfigValues = {
  isAIFeature: 1,
  actionSubjectId: 'client',
  eventDispatcherSource: EventDispatcherSources.JSLib,
  skipAISessionValidation: false,
  useDefaultGASv3EventSchema: false
};